import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rel-selection" }
const _hoisted_2 = { class: "rel-selection-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_ontos_remove_button = _resolveComponent("ontos-remove-button")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_ontos_color_accent, {
      vertical: "",
      color: _ctx.optionColorOf(_ctx.item),
      class: "rel-accent"
    }, null, 8, ["color"]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.item._identifier || _ctx.item.raw?._identifier), 1),
    (_ctx.removable)
      ? (_openBlock(), _createBlock(_component_ontos_remove_button, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('remove', _ctx.item)), ["stop","prevent"]))
        }))
      : _createCommentVNode("", true)
  ]))
}